enum DuesConstants {
  GET_CLIENT_DUES_REQUEST = "GET_CLIENT_DUES_REQUEST",
  GET_CLIENT_DUES_SUCCESS = "GET_CLIENT_DUES_SUCCESS",
  GET_CLIENT_DUES_FAILURE = "GET_CLIENT_DUES_FAILURE",

  GET_INVOICE_DUES_REQUEST = "GET_INVOICE_DUES_REQUEST",
  GET_INVOICE_DUES_SUCCESS = "GET_INVOICE_DUES_SUCCESS",
  GET_INVOICE_DUES_FAILURE = "GET_INVOICE_DUES_FAILURE",

  RESET_DUES = "RESET_DUES",
}

export default DuesConstants;
